export default __webpack_public_path__ + "static/media/gardenbasecolor.72e0a88b.png";